// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./polyfills/dateDisplayPatch";
import "./index.css";
import { UserProvider } from "./context/UserContext";
import PopupHost from "./components/common/PopupHost";
import { installPopupOverrides } from "./utils/popup";
import "react-datepicker/dist/react-datepicker.css";

installPopupOverrides();

window.addEventListener("storage", (e) => {
  if (e.key === "force-logout") {
    // Make sure every tab clears everything
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("activeRole");
    localStorage.removeItem("roles");
    // Optional: force navigation if this tab is on a protected route
    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <App />
      <PopupHost />
    </UserProvider>
  </React.StrictMode>
);
